module.exports = __webpack_public_path__ + "img/symbol_7.be6c2e4b.png";